import { j as json } from "../../../../chunks/index.js";
import { g as updatePost } from "../../../../chunks/api.js";
async function POST({ request, locals }) {
  const { slug, title, content, teaser, teaser_image, recipients, is_public } = await request.json();
  const result = await updatePost(
    slug,
    title,
    content,
    teaser,
    teaser_image,
    recipients,
    is_public,
    locals
    // currentUser, origin, etc.
  );
  return json(result);
}
export {
  POST
};
